<div>
    <i class="fas fa-bell"></i>
</div>